import gql from 'graphql-tag';

const COURSE_REQUEST_FRAGMENT = gql`
  fragment CourseRequestFragment on CourseRequest {
      _id
      subject
      number
      title
      requester {
        _id
        first
        last
      }
      university {
        _id
        name
      }
  }
`;

export const FETCH_COURSE_REQUESTS_QUERY = gql`
  {
    adminCourseRequests {
      ...CourseRequestFragment
    }
  }
  ${COURSE_REQUEST_FRAGMENT}
`;

export const RESOLVE_COURSE_REQUEST_MUTATION = gql`
  mutation resolveCourseRequest($request: ID!, $courseInput: CourseInput!, $university: ID!) {
    resolveCourseRequest(_request: $request, course: $courseInput, _university: $university) {
      ...CourseRequestFragment
    }
  }
  ${COURSE_REQUEST_FRAGMENT}
`;

export const ENABLE_TUTOR_PRIVATE_LOCATION_MUTATION = gql`
  mutation enableTutorPrivateLocations($tutor: ID!) {
    enableTutorPrivateLocations(_tutor: $tutor) {
      _id
    }
  }
`;

export const DISABLE_TUTOR_PRIVATE_LOCATION_MUTATION = gql`
  mutation disableTutorPrivateLocations($tutor: ID!) {
    disableTutorPrivateLocations(_tutor: $tutor) {
      _id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/requests/api.js